import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSkinConcernPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionSkinConcern.heading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button1'),
          value: 'acne_breakouts',
        },
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button2'),
          value: 'large_pores',
        },
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button3'),
          value: 'dryness_flaking',
        },
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button4'),
          value: 'dark_circles',
        },
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button5'),
          value: 'dark_spots',
        },
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button6'),
          value: 'redness_irritation',
        },
        {
          text: t('pages.onboarding.v1.questionSkinConcern.button7'),
          value: 'other',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
